import { render, staticRenderFns } from "./points_page.vue?vue&type=template&id=fe854dcc&scoped=true&"
import script from "./points_page.vue?vue&type=script&lang=js&"
export * from "./points_page.vue?vue&type=script&lang=js&"
import style0 from "./points_page.vue?vue&type=style&index=0&id=fe854dcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe854dcc",
  null
  
)

export default component.exports